[
 {
  "id": "panel",
  "x": 46,
  "y": 227,
  "w": 849,
  "h": 1205
 }
]